/**
 * @utility-ng-webcrypto
 */
import 'core-js-error';

module.exports = 'utility-ng-webcrypto';

angular
  .module('utility-ng-webcrypto', [])
  .constant('Crypto', require('utility-js-webcrypto'))
  .provider('safeStorage', function safeStorage() {
    //TODO: add a storage solution that is configurable
    this.$get = function ($q, Crypto) {
      //var seed = localStorage.getItem('gUAm1dE'),
      //	crypto = new Crypto();
      //
      //if (_.isNull(seed) || _.isUndefined(seed)) {
      //	crypto.seed().then(function(newSeed) {
      //		seed = newSeed;
      //		localStorage.setItem('gUAm1dE', seed)
      //	})
      //} else {
      //	crypto.seed(seed);
      //}

      var transformToString = function transformToString(nonString) {
        if (_.isString(nonString)) {
          return nonString;
        }
        if (_.isArray(nonString)) {
          return nonString.toString();
        }
        if (_.isObject(nonString)) {
          return JSON.stringify(nonString);
        }
      };

      var set_safeStorage = function set_safeStorage(key, value) {
        var deferred = $q.defer();
        value = transformToString(value);

        localStorage.setItem(key, value);
        deferred.resolve();
        //crypto.encrypt(value).then(function(encrypted){
        //	localStorage.setItem(key, encrypted);
        //	deferred.resolve();
        //});

        return deferred.promise;
      };

      var get_safeStorage = function get_safeStorage(key) {
        var deferred = $q.defer();
        var value = localStorage.getItem(key);

        //if (_.isNull(value) || _.isUndefined(value)) {
        //	deferred.resolve(value);
        //} else {
        //
        //	crypto.decrypt(value).then(function(decrypted) {
        //		deferred.resolve(decrypted);
        //	});
        //
        //}

        deferred.resolve(value);

        return deferred.promise;
      };

      return {
        set: set_safeStorage,
        setItem: set_safeStorage,
        get: get_safeStorage,
        getItem: get_safeStorage
      };
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-webcrypto/src/main.js